import React from "react";
import { Row, Col, Input, Button, Space, Dropdown, message, Select, Image, Tooltip, Table } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import ParentInvoiceStore from "../store/ParentInvoiceStore";
import NotificationStore from "../store/NotificationStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";

class ParentInvoiceDetails extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleChange = this.handleChange.bind(this);


        this.parentInvoiceStore = new ParentInvoiceStore();
        this.notificationStore = new NotificationStore();
        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            openConfirm: false,
            confirmLoading: false,
            companyId: "",
            loadList: 0,
            openParentAddForm: false,
            parentId: "",
            listDataUpdate: false,
            companyFieldHighlight: false,
            searchField: "",
            classId: "",
            openDeleteModal: false,
            deleteData: {},
            studentsMap: {},   // { parentId: [students] }
            loadingMap: {},    // { parentId: true/false }
        };

        this.columns = [

            {
                // title: "Parents Name",
                title: context.translate("_PARENTS_NAME_"),
                width: 150,
                dataIndex: "parentName",
                key: "parentName",
                ellipsis: {
                    showTitle: true,
                },
                fixed: "left",
            },
            {
                title: context.translate("_STUDENT_NAME_"),
                width: 150,
                dataIndex: "studentName",
                key: "studentName",
                ellipsis: {
                    showTitle: true,
                },
                fixed: "left",
            },
            {
                title: context.translate("_INVOICE_DATE_"),
                width: 150,
                dataIndex: "invoiceDate",
                key: "invoiceDate",
                ellipsis: {
                    showTitle: true,
                },
                fixed: "left",
            },
            {
                title: context.translate("_MONTH_"),
                width: 150,
                dataIndex: "month",
                key: "month",
                ellipsis: {
                    showTitle: true,
                },
                fixed: "left",
            },
            {
                title: context.translate("_YEAR_"),
                width: 150,
                dataIndex: "year",
                key: "year",
                ellipsis: {
                    showTitle: true,
                },
                fixed: "left",
            },
            {
                title: context.translate("_BUS_PAYMENT_PER_DAY_"),
                width: 150,
                dataIndex: "busPaymentPerDay",
                key: "busPaymentPerDay",
                ellipsis: {
                    showTitle: true,
                },
                fixed: "left",
            },
            {
                title: context.translate("_TOTAL_AMOUNT_"),
                width: 150,
                dataIndex: "totalAmount",
                key: "totalAmount",
                ellipsis: {
                    showTitle: true,
                },
                fixed: "left",
            },
            {
                title: context.translate("_PAYMENT_STATUS_"),
                width: 150,
                dataIndex: "paymentStatus",
                key: "paymentStatus",
                ellipsis: {
                    showTitle: true,
                },
                fixed: "left",
            },


        ];

        this.ExportMenuProps = {
            items: [
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={Excel}
                            ></Image>
                            {context.translate("_EXPORT_AS_EXCEL_")}
                        </div>
                    ),
                    key: "excel",
                }

            ],
            onClick: (val) => {
                let result = [];
                if (true) {
                    this.columns.map((obj) => result.push(obj.dataIndex));
                    var getData = {
                        companyId: this.state.companyId,
                        colList: result.toString(),
                    };
                    if (val.key === "excel") {
                        this.parentInvoiceStore.exportExcel(getData);
                    }

                }
            },
        };
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.listDataUpdate !== this.state.listDataUpdate) {
            await this.handleSearch();
        }
    }
    async componentDidMount() {
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ userId: this.props.getUserData().userId });
            await this.handleSearch();
        }
        this.setState({ pageSize: 50 });


    }
    async handleTableChange(pagination) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        this.handleSearch();
    }

    async handleChange(comp) {
        await this.setState({
            companyId: comp.value,
            searchField: "",
            classId: "",
        });
        console.log(comp);
        await this.handleSearch();
    }

    async handleSearch() {
        this.setState({ loading: true });
        await this.parentInvoiceStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId,
        });
        await this.setState({ loadList: 1 });
    }

    refreshList = async () => {
        if (this.state.companyId) {

            await this.parentInvoiceStore.loadData({
                offset: 0,
                limit: 50,
                companyId: this.state.companyId,
                searchField: "",
            });
            this.setState({
                loading: false,
                currentPage: 1,
                searchField: "",
                classId: "",
            });
        }
    };

    render() {
        const companyInputBox = this.state.companyFieldHighlight
            ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
            : { width: "150px" };
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={this.handleChange}
                                    style={companyInputBox}
                                />
                            </Space>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={4}
                        >
                            <Space>
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            // marginInlineEnd: "20px",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>
                                <Button
                                    className="downloadExcelButton"
                                    disabled={
                                        this.parentInvoiceStore?.invoiceDetails?.length > 0 ? false : true
                                    }
                                >
                                    <Dropdown
                                        overlayClassName="export-dropdown"
                                        menu={this.ExportMenuProps}
                                    >
                                        <Image
                                            style={{
                                                height: 18,
                                                alignItems: "center",
                                                marginInlineEnd: "30px",
                                            }}
                                            src={downloadIcon}
                                        ></Image>
                                    </Dropdown>
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <ListTable
                        current={this.state.currentPage}
                        total={this.parentInvoiceStore?.total}
                        columns={this.columns}
                        dataSource={this.parentInvoiceStore?.invoiceDetails}
                        loading={this.parentInvoiceStore?.loading}
                        onChange={this.handleTableChange}
                        rowKey="invoiceId"
                    />
                </div>


            </>
        );
    }
}
ParentInvoiceDetails.contextType = StoreContext;
export default observer(withRouter(ParentInvoiceDetails));
